<template>
  <div class="i-money-back-guarantee">
    <div
      class="money-back-img"
      :class="{ small: props.version === 'v2' }"
    >
      <img
        :src="iconMoneyBackGuarantee"
        loading="lazy"
        alt="Money Back Guarantee"
        class="img"
      />
    </div>
    <div class="money-back-text-block">
      <iSectionTitle
        class="text-block-title"
        :class="{ small: props.version === 'v2' }"
      >
        100% Money-Back Guarantee
      </iSectionTitle>

      <div
        class="text-block-content"
        :class="{ small: props.version === 'v2' }"
      >
        We believe that our report will help you find and achieve professional success and fulfillment. If our report
        doesn't deliver what it promises, we will refund your money. Please double check our
        <a
          href="https://www.jobtest.org/refund-policy"
          target="_blank"
          >Refund Policy</a
        >
        for more details.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import iSectionTitle from "@/components/welcome/SectionTitle.vue"

// ASSETS
import iconMoneyBackGuarantee from "@/assets/icons/icon-money-back-30.svg"

// PROPS
const props = defineProps({
  version: {
    type: String as () => "v1" | "v2",
    default: "v1"
  }
})
</script>

<style scoped lang="scss">
.i-money-back-guarantee {
  @include flex(column, center, center, $gap: 8px);

  background-color: $white;
  border-radius: 24px;

  .money-back-img {
    width: 100%;
    text-align: center;

    .img {
      width: 100%;
      max-width: 180px;
    }

    &.small {
      .img {
        max-width: 120px;
      }
    }
  }

  .money-back-text-block {
    width: 100%;
    text-align: center;

    .text-block-title {
      @include display-sm;

      &.small {
        @include display-xs;
      }
    }

    .text-block-content {
      @include text-lg;

      margin-top: 10px;
      letter-spacing: 0;
      color: $black900;
      font-weight: 400;

      &.small {
        @include text-sm;
      }

      @media screen and (min-width: $breakpoint-md) {
        @include text-xl;
      }

      a {
        text-decoration: underline;
        color: $astronaut500;
        cursor: pointer;
      }
    }

    .refund-link {
      @include text-link;

      color: $astronaut600;
      border-bottom: 1px solid $astronaut600;
    }

    .refund-title {
      @include text-xl;

      font-weight: bold;
    }
  }
}
</style>
